import { api } from 'src/utils/api';

export const create = ({
    fk_bank, agency, account, account_digit, account_name, account_document, account_complement_number,
}) => api.post('/bank-accounts', {
    fk_bank,
    agency,
    account,
    account_digit,
    account_name,
    account_document,
    account_complement_number,
});

export const update = (pkBankAccount, params) => api.put(`/bank-accounts/${pkBankAccount}`, params);

export const listByAuthUser = () => api.get('/bank-accounts');

export const getBanks = () => api.get('/banks');
